<template>

    <LoopItemPanel title="Kolom">

        <div class="canvas-blocks-custom-3columnimage-LoopItemPanel">

            <Linkinput :options="loopItem" ></Linkinput>

        </div>
        
        <template v-slot:actionsExtra>
            <button class="btn btn-success" @click="save">
                <i class="mr-2 fas fa-check"></i> Opslaan
            </button>
        </template>

    </LoopItemPanel>

</template>

<script>

import LoopItemPanel from "@galaxy/modules/Canvas/resources/js/editor/website/editors/loop/LoopItemPanel";
import Linkinput from "@galaxy/modules/Canvas/resources/js/editor/website/editors/inputs/LinkInput";

export default {

    extends: LoopItemPanel,

    components: {
        LoopItemPanel,
        Linkinput,
    },

}

</script>
